import { styled, Tag } from '@project44/manifest-ds';

export const BodyTitle = styled('div', {
  display: 'flex',
  alignItems: 'center',
  '& > *:not(:last-child)': {
    marginRight: '$small',
  },
});

export const EntityLabelSkeleton = styled('div', {
  width: '200px',
  height: '1.5rem',
  background: '#ffffff',
  borderRadius: '9999px',
});

export const EntityLabel = styled(Tag, {
  background: '$background-primary',
  maxWidth: 'initial',
  pointerEvents: 'none',
});
